module.exports = __webpack_public_path__ + "img/header-memoireRingsSlim.784ebc4.jpg";